import { memo } from "react";

import { MarkerActiveIcon, MarkerIcon } from "./icons";

interface GenericPinProps {
  isActive?: boolean;
}

function GenericPin({ isActive = false }: GenericPinProps) {
  return (
    <div className="flex h-[71px] w-[57px] items-center justify-center">
      {isActive ? <MarkerActiveIcon /> : <MarkerIcon />}
    </div>
  );
}
export default memo(GenericPin);
